module.exports = __webpack_public_path__ + "assets/ic_coin.04362c4b.svg";